import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus } from "@fortawesome/free-solid-svg-icons";

import Spinner from "../app/Spinner";
import Modal from "../app/Modal";
import GroupForm from "./GroupForm";
import "./Groups.css";

class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      form: null,
      modalOpen: false,
      user: this.props.auth.googleId
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
  }

  componentDidMount() {
    this.props.fetchUser();
    this.props.fetchSortOptions();
    this.props.fetchGroups(localStorage.getItem("SubscriptionId"));
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.props.fetchGroups(localStorage.getItem("SubscriptionId"));
  };

  render() {
    // ***************************
    // ADD MENU FUNCTIONALITY
    const handleAddGroup = () => {
      this.setState({ form: "add", modalOpen: true });
    };

    const renderPlaceholder = () => {
      return <Spinner />;
    };

    const renderForm = type => {
      switch (type) {
        case "add":
          // return renderEditForm();
          return (
            <div>
              <GroupForm
                id=""
                data=""
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                sortOptions={this.props.sortOptions}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
              />
            </div>
          );
        default:
          return renderPlaceholder();
      }
    };

    const renderGroups = data => {
      let output = "";
      if (data) {
        output = data.map((record, index) => (
          <div key={index} className="group-thumbnail component-shadow">
            <div className="group-details">
              <div className="group-name">{record.Name}</div>
              <div className="group-type">{record.Type} Pricing</div>
            </div>
            <div className="group-actions">
              <Link
                to={"/menus/groups/" + record.Oid + "/edit"}
                className="waves-effect waves-light btn btn-icon"
              >
                <FontAwesomeIcon icon={faPen} size="lg" />
              </Link>
            </div>
          </div>
        ));
      }
      return output;
    };

    const renderContent = (
      <div className="component-group pad-20">
        <h1>Manage Groups</h1>
        <div className="component-actions">
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleAddGroup}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" /> Add Group
          </button>
        </div>
        <div>
          <div className="group-container">
            {renderGroups(this.props.groups)}
          </div>
        </div>
        <div className="component-footer"></div>
      </div>
    );

    return (
      <div className="component-groups">
        {renderContent}
        <Modal modalOpen={this.state.modalOpen}>
          {renderForm(this.state.form, this.state.data)}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    groups: state.groups,
    sortOptions: state.sortOptions
  };
}

export default connect(
  mapStateToProps,
  actions
)(Groups);
